export default {
      id: "play-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#play-usage",
      toString: function () {
        return this.url;
      }
    }